// Copyright (c) Docugami, Inc. All rights reserved.

export enum SampleStatus {
    Ready,
    Installing,
    Uninstalled,
    Error
}

export interface Sample {
    id: string;
    name: string;
    description: string;
    industries: SampleIndustry[];
    status: SampleStatus;
}

export enum SampleIndustry {
    Aerospace = "Aerospace",
    Construction = "Construction",
    EnergyAndUtilities = "EnergyAndUtilities",
    FinancialServices = "FinancialServices",
    Healthcare = "Healthcare",
    InformationTechnology = "InformationTechnology",
    Insurance = "Insurance",
    LegalServices = "LegalServices",
    Manufacturing = "Manufacturing",
    Pharmaceuticals = "Pharmaceuticals",
    RealEstate = "RealEstate",
    Telecommunications = "Telecommunications",
    TransportationAndLogistics = "TransportationAndLogistics",
    Other = "Other"
}

// API models
export interface SampleCatalogResponse {
    id: string;
    name: string;
    description: string;
    industries: SampleIndustry[];
    version: string;
}

export interface SampleResponse {
    id: string;
    catalog?: {
        id: string
    };
    name: string;
    description: string;
    version?: string;
    status: SampleStatus;
}

export interface DocSetReadyModel {
    organizationId: string;
    clusterId: string;
    succeeded: boolean;
    isSample: boolean;
}
